import _ from "lodash";
import { toastr } from "react-redux-toastr";
import { client_config } from "../utils/clientConfigs";


export default function formatFoldersForSelect(folders) {

  function calculateFolderNesting(folder, nestingLevel = 0) {
    if (folder.parentid_bi === null) {
      return nestingLevel;
    }

    if (folder.parentid_bi === folder.folder_id_bint) {
      toastr.error("Oops", `It appears folder "${folder.title_vch}" has itself as a parent...`);
      return nestingLevel;
    }

    const parentFolder = _.find(folders, { folder_id_bint: folder.parentid_bi });

    if (!parentFolder) {
      return toastr.error(`Oops`, `Can't find parent folder for "${folder.title_vch}"`);
    }

    return calculateFolderNesting(parentFolder, nestingLevel + 1);
  }

  const options = _.chain(folders)
    .sortBy((folder) => {
      folder.sort = getParentSortArray(folders, folder);
      return folder.sort;
    })
    .map((folder) => ({
      label: folder.title_vch,
      value: folder.folder_id_bint,
      nest: calculateFolderNesting(folder),
      sort: folder.sort,
    }))
    .value();

  if (!client_config.enabled_features.do_not_select_folder_disable) { //DE-2088, disabled for DUKE
    options.unshift({ label: "Do not put in sub-folder", value: null }); // Allow user to create root level folder
  }
  options.unshift({ label: "Choose a folder", value: -1, isDisabled: true });

  return options;
}

/**
 * Function to handle multi-level sorting
 * @param {Array}   folders
 * @param {Object}  folder
 * @param {Array}   [parent_array]
 * @returns {Number[]}
 */
function getParentSortArray(folders, folder, parent_array = []) {
  parent_array.unshift(folder.folder_id_bint);

  // If folder is "root" folder, return immediately
  if (folder.parentid_bi === null) {
    return parent_array;
  }

  const parent = folders.find((parent) => parent.folder_id_bint === folder.parentid_bi);

  // If parent is not a "root" folder - prepend parent folder's details (recursive)
  if (parent.parentid_bi !== null) {
    return getParentSortArray(folders, parent, parent_array);
  }

  // Else prepend parent's details and return
  parent_array.unshift(folder.parentid_bi);
  return parent_array;
}

export function formatAndHideFoldersForSelect(folders) {
  const filteredFolders = folders.filter(f => f.show_int === 1)

  function calculateFolderNesting(folder, nestingLevel = 0) {
    if (folder.parentid_bi === null) {
      return nestingLevel;
    }

    if (folder.parentid_bi === folder.folder_id_bint) {
      toastr.error("Oops", `It appears folder "${folder.title_vch}" has itself as a parent...`);
      return nestingLevel;
    }

    const parentFolder = _.find(folders, { folder_id_bint: folder.parentid_bi });

    if (!parentFolder) {
      return toastr.error(`Oops`, `Can't find parent folder for "${folder.title_vch}"`);
    }

    return calculateFolderNesting(parentFolder, nestingLevel + 1);
  }

  const options = _.chain(filteredFolders)
    .sortBy((folder) => {
      folder.sort = getParentSortArray(folders, folder);
      return folder.sort;
    })
    .map((folder) => ({
      label: folder.title_vch,
      value: folder.folder_id_bint,
      nest: calculateFolderNesting(folder),
      sort: folder.sort,
    }))
    .value();

  if (!client_config.enabled_features.do_not_select_folder_disable) { //DE-2088, disabled for DUKE
    options.unshift({ label: "Do not put in sub-folder", value: null }); // Allow user to create root level folder
  }
  options.unshift({ label: "Choose a folder", value: -1, isDisabled: true });

  return options;
}
